import { DatePipe } from "@angular/common";
import { HttpErrorResponse } from "@angular/common/http";
import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ViewChild,
  ChangeDetectorRef,
} from "@angular/core";
import { FormBuilder, FormControl, FormGroup, NgForm, Validators } from "@angular/forms";

import { SignaturePad } from "angular2-signaturepad";
import { IMyDateModel, IMyDpOptions, IMyInputFieldChanged } from "mydatepicker";
import { ToastrService } from "ngx-toastr";
import { parse } from "path";
import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { CommonHttpService } from "src/app/common.service";
import { DateService } from "src/app/date.service";
import { GlobalComponent } from "src/app/global/global.component";
import { GeneralService } from "src/app/service/general.service";
import { employeeTemplate } from "../agreement-template/agreement-template.model";
import { EmployeeService } from "../employee/employee.service";
import {
  BackgroundStudyAuthorizationTemplateBO,
  DswBackgroundStudyInfoTemplateBO,
  EmployeeAgreementAndDirectDepositTemplateBO,
  EmployeeAgreementTemplateBO,
  EmployeeApplicationCoverTemplateBO,
  EmployeesWithholdingCertificateTemplateBO,
  EmploymentEligibilityVerificationTemplateBO,
  functionpermission,
  IndividualDirectSupportWorkerEnrollmentApplicationTemplateBO,
  IndividualSupportWorkerProviderAgreementTemplateBO,
  PayNoticeTemplateBO,
  RelationshipDisclosureTemplateBO,
  W4MinnesotaWithholdingAllowanceOrExemptionCertificateTemplateBO,
  W4MNInstructionsForEmployeesAndPensionOrAnnuityRecipientsTemplateBO,
} from "./employee-agreement-template.model";
import { EmployeeAgreementTemplateService } from "./employee-agreement-template.service";

@Component({
  selector: "app-employee-agreement-template",
  templateUrl: "./employee-agreement-template.component.html",
  styleUrls: ["./employee-agreement-template.component.scss"],
})
export class EmployeeAgreementTemplateComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  @Input() employeeTemplate = new employeeTemplate();
  @Output() dataEmitemployeeTemplate = new EventEmitter<employeeTemplate>();
  stateform:FormGroup
  section1radio:any;
  /////model of agreement//////

  EmployeeTemplateBo: EmployeeAgreementTemplateBO =
    new EmployeeAgreementTemplateBO();

  templateBo: EmployeeAgreementTemplateBO = new EmployeeAgreementTemplateBO();


  backgroundBo = new BackgroundStudyAuthorizationTemplateBO();

  backgroundInfoBo: DswBackgroundStudyInfoTemplateBO[] = [];

  directdepositBo = new EmployeeAgreementAndDirectDepositTemplateBO();
  coverTemplateBo = new EmployeeApplicationCoverTemplateBO();
  withHoldBo = new EmployeesWithholdingCertificateTemplateBO();
  eligibilityBo = new EmploymentEligibilityVerificationTemplateBO();
  directSupportWorker =
    new IndividualDirectSupportWorkerEnrollmentApplicationTemplateBO();
  supportWorkerBo = new IndividualSupportWorkerProviderAgreementTemplateBO();
  PayNoticeTemplateBO = new PayNoticeTemplateBO();
  relationshipDisclosureBo = new RelationshipDisclosureTemplateBO();
  w4MinnesotaWithholdingBo =
    new W4MinnesotaWithholdingAllowanceOrExemptionCertificateTemplateBO();
  w4MNInstructionsForEmployeesBo =
    new W4MNInstructionsForEmployeesAndPensionOrAnnuityRecipientsTemplateBO();

    DSwstudyBolistarray = {
      bsgNumber: null,
      applicationNumber: null,
      facilityId: null,
      isadd: true,
    };
  Employeesign: string = "";
  Gurdiansign: string = "";
  Gsign: string = "";
  PreviousName: any = [];
  payRateList: any = [];
  isUpdate: boolean = false;
  templateid: string;
  drawCompleteEmployeesign() {
    this.Employeesign = this.EnrollmentsignaturePad.toDataURL();
    this.applicantSignatureName = this.Employeesign;
  }
  applicantSignatureName: string = "";
  ClearEmployeeSignature() {
    this.EnrollmentsignaturePad.clear();
    this.Employeesign = "";
  }
  drawCompleteGurdiansign() {
    this.Gurdiansign = this.GurdiansignaturePad.toDataURL();
  }
  drawGurdiansign() {
    this.Gsign = this.GurdianPad.toDataURL();
  }
  ClearGurdianSignature1() {
    this.GurdianPad.clear();
    this.Gsign = "";
  }
  ClearGurdianSignature() {
    this.GurdiansignaturePad.clear();
    this.Gurdiansign = "";
  }
  applicantsign = "";
  drawCompleteapplicantsign() {
    this.applicantsign = this.ApplicantsignaturePad.toDataURL();
  }
  clearApplicantsign() {
    this.ApplicantsignaturePad.clear();
    this.applicantsign = "";
  }
  legalsign = "";
  drawCompletelegalsign() {
    this.legalsign = this.LegalsignaturePad.toDataURL();
  }
  clearLegalsign() {
    this.LegalsignaturePad.clear();
    this.legalsign = "";
  }

  yes_or_no_lst: [];
  // get_yes_or_noLSt() {
  //   let params = new URLSearchParams();
  //   params.append("Code", "YESORNO");
  //   this.employeeservice.getcommon(params).subscribe((data: any) => {
  //     this.yes_or_no_lst = data;
  //   });
  // }

  relation_lst = [];
  // get_relation_lst() {
  //   let params = new URLSearchParams();
  //   params.append("Code", "RELATIONLIST");
  //   this.employeeservice.getcommon(params).subscribe((data: any) => {
  //     this.relation_lst = data;
  //   });
  // }
  EducationColumn: boolean = false;
  doctype: string = "";
  changedModel = [
    {
      name: "Asian",
    },
    {
      name: "Pacific Islander",
    },
    {
      name: "African American",
    },
    {
      name: "Native American",
    },
    {
      name: "White",
    },
    {
      name: "Hispanic/Latino",
    },
    {
      name: "Unknown/Other",
    },
    {
      name: "Two or More Races",
    },
  ];

  public myDatePickerOptionsDOB: IMyDpOptions = {
    dateFormat: "mm/dd/yyyy",
    showClearDateBtn: false,
    editableDateField: true,
  };
  @ViewChild("EnrollmentsignaturePad") EnrollmentsignaturePad: SignaturePad;
  @ViewChild("GurdiansignaturePad") GurdiansignaturePad: SignaturePad;
  @ViewChild("GurdianPad") GurdianPad: SignaturePad;
  @ViewChild("ApplicantsignaturePad") ApplicantsignaturePad: SignaturePad;
  @ViewChild("LegalsignaturePad") LegalsignaturePad: SignaturePad;
  @ViewChild("rollPad") rollPad: SignaturePad;
  @ViewChild("rollPad1") rollPad1: SignaturePad;
  @ViewChild("rollPad2") rollPad2: SignaturePad;
  @ViewChild("rollPad3") rollPad3: SignaturePad;
  @ViewChild("rollPad4") rollPad4: SignaturePad;
  @ViewChild("appsignpad") appsignpad: SignaturePad;
  @ViewChild("parentsignpad") parentsignpad: SignaturePad;
  @ViewChild("authsignpad") authsignpad: SignaturePad;
  @ViewChild("EnPad") EnPad: SignaturePad;
  @ViewChild("Pad") Pad: SignaturePad;
  @ViewChild("EnrollPad_2") EnrollPad_2: SignaturePad;
  @ViewChild("EmpSignPad") EmpSignPad: SignaturePad;
  @ViewChild("EnrollPad") EnrollPad: SignaturePad;
  @ViewChild("EnrollPad_EMP") EnrollPad_EMP: SignaturePad;
  @ViewChild("EnrollPad_APP") EnrollPad_APP: SignaturePad;

  drawCompleteEmpsign() {
    this.Employeesign = this.EmpSignPad.toDataURL();
  }
  ClearEmployee_sign() {
    this.EnrollPad_2.clear();
    this.employeesign = "";
  }
  ClearEmployee_sign1() {
    this.EnrollPad_EMP.clear();
    this.employeesign2 = "";
  }
  ClearApplicant_sign() {
    this.EnrollPad_APP.clear();
    this.clientsign0 = "";
  }
  drawsign() {
    this.Gurdiansign = this.EnrollPad.toDataURL();
  }
  employeesign2: any;
  drawsign_employer() {
    this.employeesign2 = this.EnrollPad_EMP.toDataURL();
  }
  employeesign3: any;
  drawsign_employer_2() {
    this.employeesign3 = this.EnrollPad_2.toDataURL();
  }

  clearemployyesing3() {
    this.EnrollPad_2.clear();
    this.employeesign3 = "";
  }
  clientsign0: any;
  drawsign_applicant() {
    this.clientsign0 = this.EnrollPad_APP.toDataURL();
  }

  ClearEmployeeSignature1() {
    this.EmpSignPad.clear();
    this.Employeesign = "";
  }
  ClearEmployeeSignature2() {
    this.EnrollPad.clear();
    this.Gurdiansign = "";
  }
  sign1() {
    this.clientsign = this.Pad.toDataURL();
  }
  ClearEmployeeSignature3() {
    this.Pad.clear();
    this.clientsign = "";
  }

  clientsign: string = "";
  public signaturePadOptions: Object = {
    minWidth: 5,
    canvasWidth: 500,
    canvasHeight: 200,
    maxWidth: 2,
    penColor: "blue",
  }
  disable:boolean=true
  public versionform: FormGroup;
  public Document1: FormGroup;
  public dh1form: FormGroup;
  public statusform: FormGroup;
  public EmployeeWithholding: FormGroup;
  avoidgetId: string;
  updateTemplate=false
  Section1Form:FormGroup
  Section2Form:FormGroup
  constructor(
    public general: GeneralService,
    public commonStatehttp: CommonHttpService,
    public toastrService: ToastrService,
    public global: GlobalComponent,
    public dateservice: DateService,
    private formBuilder: FormBuilder,

    private employeeTemplateservice: EmployeeAgreementTemplateService,
    private afterChangedError: ChangeDetectorRef,
    public datepipe: DatePipe,
    public commonhttp: CommonHttpService,
    public employeeService: EmployeeService
  ) {
    this.global.checkforlogout();

    this.Section1Form = new FormGroup({
      
      input1: new FormControl(''),
      input2:new FormControl(''),
      input3:new FormControl(''),
      input4:new FormControl(''),
      input5:new FormControl(''),
      input6:new FormControl(''),
      input7: new FormControl(''),
      input8: new FormControl('')
  }),
  this.Section2Form = new FormGroup({
    input1: new FormControl(''),
    input2:new FormControl(''),
    input3:new FormControl(''),
    input4:new FormControl(''),
    input5: new FormControl('')
}),
    // this.stateform = new FormGroup({
    //   firstName: new FormControl('', [Validators.required]),
    //   lastName: new FormControl('', [Validators.required]),
    // })
    this.stateform=  new FormGroup({
      state1:new FormControl(''),
      state2:new FormControl(''),
      state3:new FormControl(''),
      state4:new FormControl(''),
      state5:new FormControl(''),
      state6:new FormControl(''),
      state7:new FormControl(''),
      gender:new FormControl('')

    })
  }
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: "mm/dd/yyyy",
    showClearDateBtn: false,
    editableDateField: true,
  };
  stateList: any = [];
  covername: string;
  public formatOptions: object;
  DSwstudyBolist=[]
  fp:functionpermission=new functionpermission()
  ngOnInit(): void {
    this.Section2Form.disable();
    this.stateform.disable();
    this.commonhttp
      .getJSON()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data) => {
        this.stateList = data;
      });
    // this.employeeBO.onboardingId = this.global.onboardingId;

    // this.commonStatehttp
    //   .getJSON()
    //   .pipe(takeUntil(this.onDestroy$))
    //   .subscribe((data) => {
    //     this.stateList = data;
    //   });

    // this.getgender();
    // this.clicktabs();
    // this.oneplusbtnName();
    // this.oneplusbtnAddress();
    // this.getEmployeeOnboardDoc();
    this.getGenderList();
    this.getTemplatedata();
    if (
      this.employeeTemplate.documentid !=
        "00000000-0000-0000-0000-000000000000"
    ) {
      this.updateTemplate=true
    }
    this.DSwstudyBolist.push(this.DSwstudyBolistarray);
  }
 
  genderlist: any;
  getGenderList() {
    let params = new URLSearchParams();
    params.append("ListCode", "GENDER");
    this.employeeService
      .getLov(params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data: any) => {
        this.genderlist = data;
      
      });
  }
  supportname() {}

  suptwrkName() {}
  clicktab(i, list) {
    if (i >= 0) {
      this.DSwstudyBolist[i].isadd = false;
    }
    let ab = {
      bsgNumber: null,
      applicationNumber: null,
      facilityId: null,
      isadd: true,
    };
    this.DSwstudyBolist.push(ab);
  }

  removeTab(i) {
    this.DSwstudyBolist.splice(i, 1);
    var length = this.DSwstudyBolist.length;
    var count = 0;
    this.DSwstudyBolist.forEach((element) => {
      if (element.isadd == false) {
        count++;
      }
    });
    if (length == count) {
      this.DSwstudyBolist[length - 1].isadd = true;
    }
  }


  onDateChangedCareAUTHStart(i, event: IMyDateModel) {
    this.PreviousName[i].previous_name_date = event.formatted;
  }
  CareAUTHStartDatengModelChange;

  CareAUTHStartDatechange(i, event: IMyInputFieldChanged) {
    let value = event.value;

    if (value.length == 5 && value.substring(2, 3) != "/") {
      this.PreviousName[i].previous_name_date =
        value.substring(0, 2) +
        "/" +
        value.substring(2, 4) +
        "/" +
        value.substring(4, 10);
    }
  }
  onDateChangedCareAUTHStart1(i, event: IMyDateModel) {}

  CareAUTHStartDatechange1(i, event: IMyInputFieldChanged) {}

  increase = [];
  increase2 = [];
  previous = {};
  previousAddress = {};

  localdata: any = [];
  editbool: boolean = false;
  dropdata: any = [];
  tablein: any = {};
  tablearr: any = [];

  hello(val) {}
  option_A(val) {}
  option_B(val) {}
  option_C(val) {}
  option_D(val) {}
  option_E(val) {}
  option_F(val) {}
  //delete_data: OnboardDocumentBO = new OnboardDocumentBO();

  get_delete_data(data) {
    // this.delete_data = data
  }
  application_cover: string = "";
  saveDocument() {}

  @ViewChild("SupportworkerPad") SupportworkerPad: SignaturePad;
  @ViewChild("depositPad") depositPad: SignaturePad;
  @ViewChild("SignatureIndividualPad") SignatureIndividualPad: SignaturePad;
  supportsign = "";
  drawCompetesupportsign() {
    this.supportsign = this.SupportworkerPad.toDataURL();
  }
  clearsupportsign() {
    this.SupportworkerPad.clear();
    this.supportsign = "";
  }
  individualsign = "";
  drawCompeteindividualsign() {
    this.individualsign = this.SignatureIndividualPad.toDataURL();
  }
  clearindividualsign() {
    this.SignatureIndividualPad.clear();
    this.individualsign = "";
  }
  create() {
    this.clientsign1 = this.EnPad.toDataURL();
  }
  clientsign1: string = "";
  ClearEmployeeSignature5() {
    this.EnPad.clear();
    this.clientsign1 = "";
  }
  create2() {
    this.clientsign2 = this.depositPad.toDataURL();
  }

  clientsign2: string = "";
  ClearEmployeeSignature6() {
    this.depositPad.clear();
    this.clientsign2 = "";
  }
  keyPress(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  draw() {
    this.Gurdsign = this.rollPad.toDataURL();
  }
  Gurdsign: string = "";
  ClearEmployeeSignature4() {
    this.rollPad.clear();
    this.Gurdsign = "";
  }
  draw1() {
    this.Gurdsign1 = this.rollPad1.toDataURL();
  }

  Gurdsign1: string = "";
  ClearEmployeeSignature7() {
    this.rollPad1.clear();
    this.Gurdsign1 = "";
  }

  draw2() {
    this.Gurdsign2 = this.rollPad2.toDataURL();
  }

  Gurdsign2: string = "";
  ClearEmployeeSignature8() {
    this.rollPad2.clear();
    this.Gurdsign2 = "";
  }

  draw3() {
    this.Gurdsign3 = this.rollPad3.toDataURL();
  }

  Gurdsign3: string = "";
  ClearEmployeeSignature9() {
    this.rollPad3.clear();
    this.Gurdsign3 = "";
  }

  draw4() {
    this.Gurdsign4 = this.rollPad4.toDataURL();
  }

  Gurdsign4: string = "";
  ClearEmployeeSignature0() {
    this.rollPad4.clear();
    this.Gurdsign4 = "";
  }

  appsign() {
    this.sign3 = this.appsignpad.toDataURL();
  }

  sign3: string = "";
  Clearapp() {
    this.appsignpad.clear();
    this.sign3 = "";
  }
  appsign1: any;
  parentsign1() {
    this.appsign1 = this.authsignpad.toDataURL();


  }
  parentsign() {
    this.sign4 = this.parentsignpad.toDataURL();
  }

  sign4: string = "";
  Clearparent() {
    this.authsignpad.clear();
    this.appsign1 = "";
  }
  Clearparent2() {
    this.parentsignpad.clear();
    this.sign4 = "";
  }

  @ViewChild("TranslatorSignaturePad") TranslatorSignaturePad: SignaturePad;
  translatorsign = "";
  drawCompetetranslatorsign() {
    this.translatorsign = this.TranslatorSignaturePad.toDataURL();
  }
  cleartranslatorsign() {
    this.TranslatorSignaturePad.clear();
    this.translatorsign = "";
  }
  @ViewChild("AuthorizedSignaturePad") AuthorizedSignaturePad: SignaturePad;
  authorizedsign = "";
  drawCompeteauthorizedsign() {
    this.authorizedsign = this.AuthorizedSignaturePad.toDataURL();
  }
  clearauthorizedsign() {
    this.AuthorizedSignaturePad.clear();
    this.authorizedsign = "";
  }
  @ViewChild("AuthorizedRepSignaturePad")
  AuthorizedRepSignaturePad: SignaturePad;
  authorizedrepsign = "";
  drawCompeteauthorizedRepsign() {
    this.authorizedrepsign = this.AuthorizedRepSignaturePad.toDataURL();
  }
  clearauthorizedRepsign() {
    this.AuthorizedRepSignaturePad.clear();
    this.authorizedrepsign = "";
  }
  @ViewChild("EmployeeSignaturePad") EmployeeSignaturePad: SignaturePad;
  employeesign = "";
  drawCompeteemployeesign() {
    this.employeesign = this.EmployeeSignaturePad.toDataURL();
  }
  clearemployeesign() {
    this.EmployeeSignaturePad.clear();
    this.employeesign = "";
  }
  @ViewChild("WageRepSignaturePad") WageRepSignaturePad: SignaturePad;
  repemployeesign = "";
  drawCompeteRepemployeesign() {
    this.repemployeesign = this.WageRepSignaturePad.toDataURL();
  }
  clearRepemployeesign() {
    this.WageRepSignaturePad.clear();
    this.repemployeesign = "";
  }

  @ViewChild("ageRepSignaturePad") ageRepSignaturePad: SignaturePad;
  repsign = "";
  drawCompeteRepsign() {
    this.repsign = this.ageRepSignaturePad.toDataURL();
  }
  clearRepsign() {
    this.ageRepSignaturePad.clear();
    this.repsign = "";
  }
  closeSignarueModal() {
    document.getElementById("i9FormModal").click();
  }
  closeBackModal1() {
    document.getElementById("BackModal1").click();
  }
  closeBackModal2() {
    document.getElementById("BackModal2").click();
  }
  closeBackModal3() {
    document.getElementById("BackModal3").click();
  }
  closeDHS_4469AModal1() {
    document.getElementById("DHS_4469AModal1").click();
  }
  closeDHS_4469AModal2() {
    document.getElementById("DHS_4469AModal2").click();
  }
  closeEmployeeGenModal1() {
    document.getElementById("Employee_GenModal1").click();
  }
  closeEmployeeGenModal2() {
    document.getElementById("Employee_GenModal2").click();
  }
  closeFEAModal1() {
    document.getElementById("FEA_EmpModal1").click();
  }
  closeWageModal1() {
    document.getElementById("WageModal1").click();
  }
  closeageModal1() {
    document.getElementById("ageModal1").click();
  }
  closeTranslatorModal() {
    document.getElementById("TranslatorModal").click();
  }
  closeAuthorizedModal() {
    document.getElementById("AuthorizedModal").click();
  }
  closeAuthorizedRepModal() {
    document.getElementById("AuthorizedRepModal").click();
  }
  closeNurseModal() {
    document.getElementById("NurseSignModal").click();
  }
  closeNurseSignModal() {
    document.getElementById("NurseSign").click();
  }


  IDSWFormRadio1(){
    let ab:any
    ab =this.individualDirectSupportBoRadio1    
    this.directSupportWorker.isMcoClaimsOnly=JSON.parse(ab)
  }
  IDSWFormRadio2(){
    let ab:any
    ab =this.individualDirectSupportBoRadio2
    this.directSupportWorker.isQualifiedEnhancedRateTraining=JSON.parse(ab);
  }
  individualDirectSupportBoRadio1:string;
  individualDirectSupportBoRadio2:string;
  individualDirectSupportBoRadio3:string;


  IDSWFormRadio3(){
    let ab:any
    ab =this.individualDirectSupportBoRadio3
    this.directSupportWorker.isAffiliateIndividualDsw=JSON.parse(ab)

  }

  // getgender() {
  //   //  {
  //   if (this.employeeBO.edit == true) {
  //     let params = new URLSearchParams();
  //     params.append("Code", "GENDER");
  //     this.employeeservice
  //       .getGenderLov(params)
  //       .pipe(takeUntil(this.onDestroy$))
  //       .subscribe((data: [{ Key: string; Value: string }]) => {
  //         this.genderlist = data;
  //       });
  //   } else {
  //     let params = new URLSearchParams();
  //     params.append("Code", "GENDER");
  //     this.employeeservice
  //       .getcomman(params)
  //       .pipe(takeUntil(this.onDestroy$))
  //       .subscribe((data: [{ Key: string; Value: string }]) => {
  //         this.genderlist = data;
  //       });
  //   }
  // }

  public DocType: any;
  type_of_DocKey: string;
  public isEdit_doctype: boolean = false;

  IsduplicateForm: boolean = false;

  gridListData: any = [];

  gridDocName: string;
  gridname(data) {
    this.gridDocName = data.documentName;
  }

  emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$";
  getId: string;
  docId: string;

  getdeleteid: string;

  saveErr: any = "";

  back() {
    this.employeeTemplate.templateToOnboard = false;
    this.dataEmitemployeeTemplate.emit(this.employeeTemplate);
  }

  work_allowed(val) {}
  hire(val) {}
  checkssn() {}
  section(val) {}
  validZip() {}
  checkValue_single1(val) {}
  w4_fun_marriedheld(val) {}
  one_bool(val) {}
  clickone(val) {}
  zip1 = false;
  zip2 = false;
  zip3 = false;
  zip4 = false;
  zip5 = false;
  zip6 = false;
  zip7 = false;
  ziperr = "";
  ssn = false;
  ssn1 = false;
  ssn2 = false;
  ssn3 = false;
  ssn4 = false;
  ssnerror = "";

  saveEmployeeTemplate() {
    this.backgroundBo.previousNamesUsedDate1 =
      this.backgroundBo.previousNamesUsedDate1 != null &&
      this.backgroundBo.previousNamesUsedDate1 != undefined &&
      this.backgroundBo.previousNamesUsedDate1 != ""
        ? this.global.getDateTimeString(
            this.backgroundBo.previousNamesUsedDate1
          )
        : null;
    this.backgroundBo.previousNamesUsedDate2 =
      this.backgroundBo.previousNamesUsedDate2 != null &&
      this.backgroundBo.previousNamesUsedDate2 != undefined &&
      this.backgroundBo.previousNamesUsedDate2 != ""
        ? this.global.getDateTimeString(
            this.backgroundBo.previousNamesUsedDate2
          )
        : null;
    this.backgroundBo.previous_Addresses_UsedDate1 =
      this.backgroundBo.previous_Addresses_UsedDate1 != null &&
      this.backgroundBo.previous_Addresses_UsedDate1 != "" &&
      this.backgroundBo.previous_Addresses_UsedDate1 != undefined
        ? this.global.getDateTimeString(
            this.backgroundBo.previous_Addresses_UsedDate1
          )
        : null;
    this.backgroundBo.previous_Addresses_UsedDate2 =
      this.backgroundBo.previous_Addresses_UsedDate2 != null &&
      this.backgroundBo.previous_Addresses_UsedDate2 != "" &&
      this.backgroundBo.previous_Addresses_UsedDate2 != undefined
        ? this.global.getDateTimeString(
            this.backgroundBo.previous_Addresses_UsedDate2
          )
        : null;
    this.backgroundBo.previous_Addresses_UsedDate3 =
      this.backgroundBo.previous_Addresses_UsedDate3 != null &&
      this.backgroundBo.previous_Addresses_UsedDate3 != "" &&
      this.backgroundBo.previous_Addresses_UsedDate3 != undefined
        ? this.global.getDateTimeString(
            this.backgroundBo.previous_Addresses_UsedDate3
          )
        : null;

    this.directSupportWorker.previousEmployementEndDate =
      this.directSupportWorker.previousEmployementEndDate != null &&
      this.directSupportWorker.previousEmployementEndDate != undefined &&
      this.directSupportWorker.previousEmployementEndDate != ""
        ? this.global.getDateTimeString(
            this.directSupportWorker.previousEmployementEndDate
          )
        : null;
    this.directSupportWorker.optionalTrainingCompletionDate =
      this.directSupportWorker.optionalTrainingCompletionDate != null &&
      this.directSupportWorker.optionalTrainingCompletionDate != "" &&
      this.directSupportWorker.optionalTrainingCompletionDate != undefined
        ? this.global.getDateTimeString(
            this.directSupportWorker.optionalTrainingCompletionDate
          )
        : null;
    this.directSupportWorker.optionalTrainingExpirationDate =
      this.directSupportWorker.optionalTrainingExpirationDate != null &&
      this.directSupportWorker.optionalTrainingExpirationDate != "" &&
      this.directSupportWorker.optionalTrainingExpirationDate != undefined
        ? this.global.getDateTimeString(
            this.directSupportWorker.optionalTrainingExpirationDate
          )
        : null;
    // this.supportWorkerBo.signDate=(this.supportWorkerBo.signDate!=null&& this.supportWorkerBo.signDate!=undefined&& this.supportWorkerBo.signDate!='')?
    // this.global.getDateTimeString(this.supportWorkerBo.signDate):null;

    this.eligibilityBo.signOfPreparerorTraslatorDate =
      this.eligibilityBo.signOfPreparerorTraslatorDate != null &&
      this.eligibilityBo.signOfPreparerorTraslatorDate != undefined &&
      this.eligibilityBo.signOfPreparerorTraslatorDate != ""
        ? this.global.getDateTimeString(
            this.eligibilityBo.signOfPreparerorTraslatorDate
          )
        : null;

    this.eligibilityBo.expirationDate =
      this.eligibilityBo.expirationDate != null &&
      this.eligibilityBo.expirationDate != undefined &&
      this.eligibilityBo.expirationDate != ""
        ? this.global.getDateTimeString(this.eligibilityBo.expirationDate)
        : null;
    this.eligibilityBo.expirationDate1 =
      this.eligibilityBo.expirationDate1 != null &&
      this.eligibilityBo.expirationDate1 != undefined &&
      this.eligibilityBo.expirationDate1 != ""
        ? this.global.getDateTimeString(this.eligibilityBo.expirationDate1)
        : null;
    this.eligibilityBo.expirationDate2 =
      this.eligibilityBo.expirationDate2 != null &&
      this.eligibilityBo.expirationDate2 != undefined &&
      this.eligibilityBo.expirationDate2 != ""
        ? this.global.getDateTimeString(this.eligibilityBo.expirationDate2)
        : null;
    this.eligibilityBo.expirationDate3 =
      this.eligibilityBo.expirationDate3 != null &&
      this.eligibilityBo.expirationDate3 != undefined &&
      this.eligibilityBo.expirationDate3 != ""
        ? this.global.getDateTimeString(this.eligibilityBo.expirationDate3)
        : null;
    this.eligibilityBo.expirationDate4 =
      this.eligibilityBo.expirationDate4 != null &&
      this.eligibilityBo.expirationDate4 != undefined &&
      this.eligibilityBo.expirationDate4 != ""
        ? this.global.getDateTimeString(this.eligibilityBo.expirationDate4)
        : null;
        this.backgroundInfoBo=this.DSwstudyBolist
    this.directSupportWorker.dswBackgroundStudyInfoTemplates =
      this.backgroundInfoBo;

    this.templateBo.backgroundStudyAuthorizationTemplate = this.backgroundBo;
    this.templateBo.employeeAgreementAndDirectDepositTemplate =
      this.directdepositBo;
    this.templateBo.employeeApplicationCoverTemplate = this.coverTemplateBo;
    this.templateBo.employmentEligibilityVerificationTemplate =
      this.eligibilityBo;
    this.templateBo.employeesWithholdingCertificateTemplate = this.withHoldBo;
    this.templateBo.individualDirectSupportWorkerEnrollmentApplicationTemplate =
      this.directSupportWorker;
    this.templateBo.individualSupportWorkerProviderAgreementTemplate =
      this.supportWorkerBo;

    this.templateBo.payNoticeTemplate = this.PayNoticeTemplateBO;

    this.templateBo.relationshipDisclosureTemplate =
      this.relationshipDisclosureBo;

    this.templateBo.w4MNInstructionsForEmployeesAndPensionOrAnnuityRecipientsTemplate =
      this.w4MNInstructionsForEmployeesBo;
    this.templateBo.w4MinnesotaWithholdingAllowanceOrExemptionCertificateTemplate =
      this.w4MinnesotaWithholdingBo;

if (this.employeeTemplate.documentid ==
        "00000000-0000-0000-0000-000000000000"){
      this.templateBo.id = "00000000-0000-0000-0000-000000000000";
    } 
    else {
      this.templateBo.id = this.employeeTemplate.documentid;
    }
this.templateBo.name=this.employeeTemplate.templateName
    this.employeeTemplateservice
      .saveEmployeeTemplate(this.templateBo)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data) => {
      
        this.global.employeeTemplateId=data
        this.employeeTemplate.documentid=data
        this.toastrService.success("Template Created Successfully")
        this.back();
      }
      );
  }

  newdates(event, type, name) {
    if (type == "inputchange") {
      if (name == "date") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.backgroundBo.previousNamesUsedDate1 = val1;
        }
      }

      if (name == "date1") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.backgroundBo.previousNamesUsedDate2 = val1;
        }
      }

      if (name == "date2") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.backgroundBo.previous_Addresses_UsedDate1 = val1;
        }
      }

      if (name == "date3") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.backgroundBo.previous_Addresses_UsedDate2 = val1;
        }
      }

      if (name == "date4") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.backgroundBo.previous_Addresses_UsedDate3 = val1;
        }
      }

      if (name == "date5") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.directSupportWorker.previousEmployementEndDate = val1;
        }
      }

      if (name == "date6") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.directSupportWorker.optionalTrainingCompletionDate = val1;
        }
      }

      if (name == "date7") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.directSupportWorker.optionalTrainingExpirationDate = val1;
        }
      }

      // if (name == "date8") {
      //   let val = this.dateservice.inputFeildchange(event);
      //   if (val != undefined) {
      //     let val1 = this.dateservice.inputFeildchange(event);
      //      this.supportWorkerBo.signDate= val1;
      //   }

      // }

      if (name == "date9") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.eligibilityBo.signOfPreparerorTraslatorDate = val1;
        }
      }

      if (name == "date10") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.eligibilityBo.expirationDate = val1;
        }
      }

      if (name == "date11") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.eligibilityBo.expirationDate1 = val1;
        }
      }

      if (name == "date12") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.eligibilityBo.expirationDate2 = val1;
        }
      }

      if (name == "date13") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.eligibilityBo.expirationDate3 = val1;
        }
      }

      if (name == "date14") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.eligibilityBo.expirationDate4 = val1;
        }
      }
    }

    if (type == "datechanged") {
      if (name == "date") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.backgroundBo.previousNamesUsedDate1 = val1;
        }
      }

      if (name == "date1") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.backgroundBo.previousNamesUsedDate2 = val1;
        }
      }

      if (name == "date2") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.backgroundBo.previous_Addresses_UsedDate1 = val1;
        }
      }

      if (name == "date3") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.backgroundBo.previous_Addresses_UsedDate2 = val1;
        }
      }

      if (name == "date4") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.backgroundBo.previous_Addresses_UsedDate3 = val1;
        }
      }

      if (name == "date5") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.directSupportWorker.previousEmployementEndDate = val1;
        }
      }

      if (name == "date6") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.directSupportWorker.optionalTrainingCompletionDate = val1;
        }
      }

      if (name == "date7") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.directSupportWorker.optionalTrainingExpirationDate = val1;
        }
      }

      //   if (name == "date8") {
      //     let val = this.dateservice.Datechange(event);
      //     if (val != undefined) {
      //       let val1 = this.dateservice.Datechange(event);
      //       this.supportWorkerBo.signDate= val1;
      //       ;
      //     }
      // }
      if (name == "date9") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.eligibilityBo.signOfPreparerorTraslatorDate = val1;
        }
      }

      if (name == "date10") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.eligibilityBo.expirationDate = val1;
        }
      }

      if (name == "date11") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.eligibilityBo.expirationDate1 = val1;
        }
      }

      if (name == "date12") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.eligibilityBo.expirationDate2 = val1;
        }
      }

      if (name == "date13") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.eligibilityBo.expirationDate3 = val1;
        }
      }

      if (name == "date14") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.eligibilityBo.expirationDate4 = val1;
        }
      }
    }

  }

  getTemplatedata() {
    console.log(this.employeeTemplate.documentid,'this.employeeTemplate.documentid');
   if(this.employeeTemplate.documentid == "00000000-0000-0000-0000-000000000000") {
    return;
   }
  
    
    let params = new URLSearchParams();
    params.append("TempleteId", this.employeeTemplate.documentid);
    this.employeeTemplateservice
      .getEmployeeTemplate(params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data) => {



        this.backgroundBo = data.backgroundStudyAuthorizationTemplate
        this.backgroundInfoBo= data.individualDirectSupportWorkerEnrollmentApplicationTemplate.dswBackgroundStudyInfoTemplates
        this.directdepositBo = data.employeeAgreementAndDirectDepositTemplate
        this.coverTemplateBo = data.employeeApplicationCoverTemplate
        this.withHoldBo =data.employeesWithholdingCertificateTemplate
        this.eligibilityBo = data.employmentEligibilityVerificationTemplate
        this.directSupportWorker =
          data.individualDirectSupportWorkerEnrollmentApplicationTemplate
        this.supportWorkerBo = data.individualSupportWorkerProviderAgreementTemplate
        this.PayNoticeTemplateBO = data.payNoticeTemplate
        this.relationshipDisclosureBo =data.relationshipDisclosureTemplate
        this.w4MinnesotaWithholdingBo = data.w4MinnesotaWithholdingAllowanceOrExemptionCertificateTemplate
        this.w4MNInstructionsForEmployeesBo =data.w4MNInstructionsForEmployeesAndPensionOrAnnuityRecipientsTemplate
        this.individualDirectSupportBoRadio2 = JSON.stringify(data.individualDirectSupportWorkerEnrollmentApplicationTemplate.isQualifiedEnhancedRateTraining);
        this.individualDirectSupportBoRadio1=JSON.stringify(data.individualDirectSupportWorkerEnrollmentApplicationTemplate.isMcoClaimsOnly)
        this.individualDirectSupportBoRadio3 = JSON.stringify(data.individualDirectSupportWorkerEnrollmentApplicationTemplate.isAffiliateIndividualDsw)
    
        this.backgroundBo.previousNamesUsedDate1 =(
          this.backgroundBo.previousNamesUsedDate1 != null &&
          this.backgroundBo.previousNamesUsedDate1 != undefined &&
          this.backgroundBo.previousNamesUsedDate1 != "")
            ? this.datepipe.transform(
                this.backgroundBo.previousNamesUsedDate1
             ,"MM/dd/yyyy"):null;
        this.backgroundBo.previousNamesUsedDate2 =(
          this.backgroundBo.previousNamesUsedDate2 != null &&
          this.backgroundBo.previousNamesUsedDate2 != undefined &&
          this.backgroundBo.previousNamesUsedDate2 != "")
            ? this.datepipe.transform(
                this.backgroundBo.previousNamesUsedDate2
             ,"MM/dd/yyyy"):null;
        this.backgroundBo.previous_Addresses_UsedDate1 =(
          this.backgroundBo.previous_Addresses_UsedDate1 != null &&
          this.backgroundBo.previous_Addresses_UsedDate1 != "" &&
          this.backgroundBo.previous_Addresses_UsedDate1 != undefined)
            ? this.datepipe.transform(
                this.backgroundBo.previous_Addresses_UsedDate1
             ,"MM/dd/yyyy"):null;
        this.backgroundBo.previous_Addresses_UsedDate2 =(
          this.backgroundBo.previous_Addresses_UsedDate2 != null &&
          this.backgroundBo.previous_Addresses_UsedDate2 != "" &&
          this.backgroundBo.previous_Addresses_UsedDate2 != undefined)
            ? this.datepipe.transform(
                this.backgroundBo.previous_Addresses_UsedDate2
             ,"MM/dd/yyyy"):null;
        this.backgroundBo.previous_Addresses_UsedDate3 =(
          this.backgroundBo.previous_Addresses_UsedDate3 != null &&
          this.backgroundBo.previous_Addresses_UsedDate3 != "" &&
          this.backgroundBo.previous_Addresses_UsedDate3 != undefined)
            ? this.datepipe.transform(
                this.backgroundBo.previous_Addresses_UsedDate3
             ,"MM/dd/yyyy"):null;
    
        this.directSupportWorker.previousEmployementEndDate =(
          this.directSupportWorker.previousEmployementEndDate != null &&
          this.directSupportWorker.previousEmployementEndDate != undefined &&
          this.directSupportWorker.previousEmployementEndDate != "")
            ? this.datepipe.transform(
                this.directSupportWorker.previousEmployementEndDate
             ,"MM/dd/yyyy"):null;
        this.directSupportWorker.optionalTrainingCompletionDate =(
          this.directSupportWorker.optionalTrainingCompletionDate != null &&
          this.directSupportWorker.optionalTrainingCompletionDate != "" &&
          this.directSupportWorker.optionalTrainingCompletionDate != undefined)
            ? this.datepipe.transform(
                this.directSupportWorker.optionalTrainingCompletionDate
             ,"MM/dd/yyyy"):null;
        this.directSupportWorker.optionalTrainingExpirationDate =(
          this.directSupportWorker.optionalTrainingExpirationDate != null &&
          this.directSupportWorker.optionalTrainingExpirationDate != "" &&
          this.directSupportWorker.optionalTrainingExpirationDate != undefined)
            ? this.datepipe.transform(
                this.directSupportWorker.optionalTrainingExpirationDate
             ,"MM/dd/yyyy"):null;
        
    
        this.eligibilityBo.signOfPreparerorTraslatorDate =(
          this.eligibilityBo.signOfPreparerorTraslatorDate != null &&
          this.eligibilityBo.signOfPreparerorTraslatorDate != undefined &&
          this.eligibilityBo.signOfPreparerorTraslatorDate != "")
            ? this.datepipe.transform(
                this.eligibilityBo.signOfPreparerorTraslatorDate
             ,"MM/dd/yyyy"):null;
    
             
        this.eligibilityBo.expirationDate =(
          this.eligibilityBo.expirationDate != null &&
          this.eligibilityBo.expirationDate != undefined &&
          this.eligibilityBo.expirationDate != "")
            ? this.datepipe.transform(this.eligibilityBo.expirationDate,"MM/dd/yyyy")
            : null;
        this.eligibilityBo.expirationDate1 =(
          this.eligibilityBo.expirationDate1 != null &&
          this.eligibilityBo.expirationDate1 != undefined &&
          this.eligibilityBo.expirationDate1 != "")
            ? this.datepipe.transform(this.eligibilityBo.expirationDate1,"MM/dd/yyyy")
            : null;
        this.eligibilityBo.expirationDate2 =(
          this.eligibilityBo.expirationDate2 != null &&
          this.eligibilityBo.expirationDate2 != undefined &&
          this.eligibilityBo.expirationDate2 != "")
            ? this.datepipe.transform(this.eligibilityBo.expirationDate2,"MM/dd/yyyy")
            : null;
        this.eligibilityBo.expirationDate3 =(
          this.eligibilityBo.expirationDate3 != null &&
          this.eligibilityBo.expirationDate3 != undefined &&
          this.eligibilityBo.expirationDate3 != "")
            ? this.datepipe.transform(this.eligibilityBo.expirationDate3,"MM/dd/yyyy")
            : null;
        this.eligibilityBo.expirationDate4 =(
          this.eligibilityBo.expirationDate4 != null &&
          this.eligibilityBo.expirationDate4 != undefined &&
          this.eligibilityBo.expirationDate4 != "")
            ? this.datepipe.transform(this.eligibilityBo.expirationDate4,"MM/dd/yyyy")
            : null;
      });
  }


  ngAfterContentChecked() {
    this.backgroundBo.previousNamesUsedDate1 =(
      this.backgroundBo.previousNamesUsedDate1 != null &&
      this.backgroundBo.previousNamesUsedDate1 != undefined &&
      this.backgroundBo.previousNamesUsedDate1 != "")
        ? this.backgroundBo.previousNamesUsedDate1
        : null;
    this.backgroundBo.previousNamesUsedDate2 =(
      this.backgroundBo.previousNamesUsedDate2 != null &&
      this.backgroundBo.previousNamesUsedDate2 != undefined &&
      this.backgroundBo.previousNamesUsedDate2 != "")
        ? this.backgroundBo.previousNamesUsedDate2
        : null;
    this.backgroundBo.previous_Addresses_UsedDate1 =(
      this.backgroundBo.previous_Addresses_UsedDate1 != null &&
      this.backgroundBo.previous_Addresses_UsedDate1 != "" &&
      this.backgroundBo.previous_Addresses_UsedDate1 != undefined)
        ? this.backgroundBo.previous_Addresses_UsedDate1
        : null;
    this.backgroundBo.previous_Addresses_UsedDate2 =(
      this.backgroundBo.previous_Addresses_UsedDate2 != null &&
      this.backgroundBo.previous_Addresses_UsedDate2 != "" &&
      this.backgroundBo.previous_Addresses_UsedDate2 != undefined)
        ? this.backgroundBo.previous_Addresses_UsedDate2
        : null;
    this.backgroundBo.previous_Addresses_UsedDate3 =(
      this.backgroundBo.previous_Addresses_UsedDate3 != null &&
      this.backgroundBo.previous_Addresses_UsedDate3 != "" &&
      this.backgroundBo.previous_Addresses_UsedDate3 != undefined)
        ? this.backgroundBo.previous_Addresses_UsedDate3
        : null;

    this.directSupportWorker.previousEmployementEndDate =(
      this.directSupportWorker.previousEmployementEndDate != null &&
      this.directSupportWorker.previousEmployementEndDate != undefined &&
      this.directSupportWorker.previousEmployementEndDate != "")
        ? this.directSupportWorker.previousEmployementEndDate
        : null;
    this.directSupportWorker.optionalTrainingCompletionDate =(
      this.directSupportWorker.optionalTrainingCompletionDate != null &&
      this.directSupportWorker.optionalTrainingCompletionDate != "" &&
      this.directSupportWorker.optionalTrainingCompletionDate != undefined)
        ? this.directSupportWorker.optionalTrainingCompletionDate
        : null;
    this.directSupportWorker.optionalTrainingExpirationDate =(
      this.directSupportWorker.optionalTrainingExpirationDate != null &&
      this.directSupportWorker.optionalTrainingExpirationDate != "" &&
      this.directSupportWorker.optionalTrainingExpirationDate != undefined)
        ? this.directSupportWorker.optionalTrainingExpirationDate
        : null;
   
    this.eligibilityBo.signOfPreparerorTraslatorDate =(
      this.eligibilityBo.signOfPreparerorTraslatorDate != null &&
      this.eligibilityBo.signOfPreparerorTraslatorDate != undefined &&
      this.eligibilityBo.signOfPreparerorTraslatorDate != "")
        ? this.eligibilityBo.signOfPreparerorTraslatorDate
        : null;

    this.eligibilityBo.expirationDate =(
      this.eligibilityBo.expirationDate != null &&
      this.eligibilityBo.expirationDate != undefined &&
      this.eligibilityBo.expirationDate != "")
        ? this.eligibilityBo.expirationDate
        : null;
    this.eligibilityBo.expirationDate1 =(
      this.eligibilityBo.expirationDate1 != null &&
      this.eligibilityBo.expirationDate1 != undefined &&
      this.eligibilityBo.expirationDate1 != "")
        ? this.eligibilityBo.expirationDate1
        : null;
    this.eligibilityBo.expirationDate2 =(
      this.eligibilityBo.expirationDate2 != null &&
      this.eligibilityBo.expirationDate2 != undefined &&
      this.eligibilityBo.expirationDate2 != "")
        ? this.eligibilityBo.expirationDate2
        : null;
    this.eligibilityBo.expirationDate3 =(
      this.eligibilityBo.expirationDate3 != null &&
      this.eligibilityBo.expirationDate3 != undefined &&
      this.eligibilityBo.expirationDate3 != "")
        ? this.eligibilityBo.expirationDate3
        : null;
    this.eligibilityBo.expirationDate4 =(
      this.eligibilityBo.expirationDate4 != null &&
      this.eligibilityBo.expirationDate4 != undefined &&
      this.eligibilityBo.expirationDate4 != "")
        ? this.eligibilityBo.expirationDate4
        : null;
  }

  DemographicPhoneFormat() {
    this.w4MinnesotaWithholdingBo.phoneNumber =
      this.general.converPhoneGoogleLib(
        this.w4MinnesotaWithholdingBo.phoneNumber
      );
   
    this.directSupportWorker.orgPersonalFax=
      this.general.converPhoneGoogleLib(
        this.directSupportWorker.orgPersonalFax
      );
  }
  

  sectionDetermine(event) {
    
    if(event.target.value=="false"){
      this.Section2Form.reset()
      this.Section2Form.disable();
      this.Section1Form.enable();
      this.w4MinnesotaWithholdingBo.exemption_minnesota_withholdingsec2=''
    }
   else if(event.target.value=="true"){
      this.Section1Form.reset()
      this.Section1Form.disable();
      this.Section2Form.enable();
    }
  }


 
  option_section2(event){
   
    if(event.target.value=="C"){
      this.Section2Form.enable();
     this.w4MinnesotaWithholdingBo.reservation_name=""
     this.w4MinnesotaWithholdingBo.enroll_no=""
     this.Section2Form.controls['input2'].disable();
     this.Section2Form.controls['input3'].disable();
     this.Section2Form.controls['input1'].enable();
     
  }
  if(event.target.value=="D"){
    this.Section2Form.enable();
   this.w4MinnesotaWithholdingBo.state_domicile=""
   this.Section2Form.controls['input1'].disable();
   this.Section2Form.controls['input2'].enable();
   this.Section2Form.controls['input3'].enable();
    
  }

  if(event.target.value!="C" && event.target.value!="D"){
    this.w4MinnesotaWithholdingBo.state_domicile=""
    this.w4MinnesotaWithholdingBo.reservation_name=""
    this.w4MinnesotaWithholdingBo.enroll_no=""
    this.Section2Form.disable();
  }



}



abc(){
console.log(this.w4MinnesotaWithholdingBo.exemption_minnesota_withholdingsec2,'w4MinnesotaWithholdingBo.exemption_minnesota_withholdingsec2"');

}
}
